import auth from './auth';
import booking from './booking';
import booking_guidelines from './booking_guidelines';
import hkust_point from './hkust_point';
import favorite_destination from './favorite_destination';
import staff from './staff';

export default {
	auth,
	booking,
	booking_guidelines,
	hkust_point,
	favorite_destination,
	staff
};
